import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import CatalogPage from "@/pages/CatalogPage";
import VehicleDetailPage from "@/pages/VehicleDetailPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AuthPage from "@/pages/AuthPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import ClientAreaPage from "@/pages/ClientAreaPage";
import ImportPage from "@/pages/ImportPage";
import SimulatorPage from "@/pages/SimulatorPage";
import ContactsPage from "@/pages/ContactsPage";
import LegalPage from "@/pages/LegalPage";
import SellerApplyPage from "@/pages/SellerApplyPage";
import SellerDashboard from "@/pages/SellerDashboard";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import CookieBanner from "@/components/CookieBanner";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App bg-white">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/viaturas" element={<CatalogPage />} />
          <Route path="/viaturas/:id" element={<VehicleDetailPage />} />
          <Route path="/importar" element={<ImportPage />} />
          <Route path="/simulador" element={<SimulatorPage />} />
          <Route path="/contactos" element={<ContactsPage />} />
          <Route path="/entrar" element={<AuthPage />} />
          <Route path="/recuperar-password" element={<ResetPasswordPage />} />
          <Route path="/conta" element={<ClientAreaPage />} />
          <Route path="/quem-somos" element={<LegalPage page="quem-somos" />} />
          <Route path="/privacidade" element={<LegalPage page="privacidade" />} />
          <Route path="/politica-de-privacidade" element={<LegalPage page="privacidade" />} />
          <Route path="/protecao-de-dados" element={<LegalPage page="protecao-dados" />} />
          <Route path="/cookies" element={<LegalPage page="cookies" />} />
          <Route path="/politica-de-cookies" element={<LegalPage page="cookies" />} />
          <Route path="/termos" element={<LegalPage page="termos" />} />
          <Route path="/termos-e-condicoes" element={<LegalPage page="termos" />} />
          <Route path="/seja-vendedor" element={<SellerApplyPage />} />
          <Route path="/vendedor" element={<SellerDashboard />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/painel" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
      <WhatsAppFloat />
      <CookieBanner />
    </div>
  );
}

export default App;
